import { IError } from '../../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IUser } from './IUser';

export interface IResultCodes {
  id: string;       // the item these result codes apply to.
  codes: number[];  // the result codes for the specified item.
}

export interface IUserActionError extends IError {
  username?: string;
}

export interface ISiteUserActionError extends IUserActionError {
  siteId?: number;
}

export interface IUserActionResult extends IResult {
  users?: IUser[];
  results?: IResultCodes[];
}

export let UserActionResultCode = {
  systemUserCreated : '10',
  siteUserCreated : '12',
  siteRoleAssigned : '30',
  userForcedPasswordUpdate: '61',
  userResetLoginRateLimiting: '62',
};
